export class UserSignupModel {
    firstName: string;
    lastName: string;
    email: string;
    companyName: string;
    mobileNumber: string;
}
